import { ref } from "vue";

const pendingRequests = ref(0);

export const isNativeLoading = pendingRequests;

export const showNativeLoading = () => {
  pendingRequests.value += 1;
};

export const hideNativeLoading = () => {
  pendingRequests.value = Math.max(0, pendingRequests.value - 1);
};
